import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    allQuestionsListLoading: false,
    allQuestionsListSuccess: null,
    allQuestionsListError: '',

    getQuestionLoading: false,
    getQuestionSuccess: null,
    getQuestionError: '',
    
    createQuestionLoading: false,
    createQuestionSuccess: {},
    createQuestionError: '',
    
    allFeedbacksLoading: false,
    allFeedbackssSuccess: {},
    allFeedbacksError: '',
    
    createFeedbackLoading: false,
    createFeedbackSuccess: {},
    createFeedbackError: '',
    
    getFeedbackDetailsLoading: false,
    getFeedbackDetailsSuccess: null,
    getFeedbackDetailsError: '',
    allFacultyLoading: false,
    allFacultySuccess: {},
    allFacultyError: '',
}

export const feedbackSlice = createSlice({
    name: 'feedbacks',
    initialState, 
    reducers: {
        setQuestionListLoading: (state) => {
            state.allQuestionsListLoading = true;
            state.allQuestionsListSuccess = null;
            state.allQuestionsListError = '';
        },
        setQuestionListSuccess: (state, action) => {
            state.allQuestionsListLoading = false;
            state.allQuestionsListSuccess = action.payload;
            state.allQuestionsListError = '';
        },
        setQuestionListError: (state, action) => {
            state.allQuestionsListLoading = false;
            state.allQuestionsListSuccess = null;
            state.allQuestionsListError = action.payload;
        },
        setGetQuestionLoading: (state) => {
            state.getQuestionLoading = true;
            state.getQuestionSuccess = {};
            state.getQuestionError = '';
        },
        setGetQuestionSuccess: (state, action) => {
            state.getQuestionLoading = false;
            state.getQuestionSuccess = action.payload;
            state.getQuestionError = '';
        },
        setGetQuestionError: (state, action) => {
            state.getQuestionLoading = false;
            state.getQuestionSuccess = {};
            state.getQuestionError = action.payload;
        },
        setCreateQuestionLoading: (state) => {
            state.createQuestionLoading = true;
            state.createQuestionSuccess = {};
            state.createQuestionError = '';
        },
        setCreateQuestionSuccess: (state, action) => {
            state.createQuestionLoading = false;
            state.createQuestionSuccess = action.payload;
            state.createQuestionError = '';
        },
        setCreateQuestionError: (state, action) => {
            state.createQuestionLoading = false;
            state.createQuestionSuccess = {};
            state.createQuestionError = action.payload;
        },
        setAllFeedbacksLoading: (state, action) => {
            state.allFeedbacksLoading = true;
            state.allFeedbackssSuccess = null;
            state.allFeedbacksError = '';
        },
        setAllFeedbacksSuccess: (state, action) => {
            state.allFeedbacksLoading = false;
            state.allFeedbackssSuccess = action.payload;
            state.allFeedbacksError = '';
        },
        setAllFeedbacksError: (state, action) => {
            state.allFeedbacksLoading = false;
            state.allFeedbackssSuccess = null;
            state.allFeedbacksError = action.payload;
        },
        setCreateFeedbackLoading: (state) => {
            state.createFeedbackLoading = true;
            state.createFeedbackSuccess = {};
            state.createFeedbackError = '';
        },
        setCreateFeedbackSuccess: (state, action) => {
            state.createFeedbackLoading = false;
            state.createFeedbackSuccess = action.payload;
            state.createFeedbackError = '';
        },
        setCreateFeedbackError: (state, action) => {
            state.createFeedbackLoading = false;
            state.createFeedbackSuccess = {};
            state.createFeedbackError = action.payload;
        },
        setGetFeedbackDetailsLoading: (state) => {
            state.getFeedbackDetailsLoading = true;
            state.getFeedbackDetailsSuccess = {};
            state.getFeedbackDetailsError = '';
        },
        setGetFeedbackDetailsSuccess: (state, action) => {
            state.getFeedbackDetailsLoading = false;
            state.getFeedbackDetailsSuccess = action.payload;
            state.getFeedbackDetailsError = '';
        },
        setGetFeedbackDetailsError: (state, action) => {
            state.getFeedbackDetailsLoading = false;
            state.getFeedbackDetailsSuccess = {};
            state.getFeedbackDetailsError = action.payload;
        },
        setAllFacultyLoading: (state, action) => {
            state.allFacultyLoading = true;
            state.allFacultySuccess = null;
            state.allFacultyError = '';
        },
        setAllFacultySuccess: (state, action) => {
            state.allFacultyLoading = false;
            state.allFacultySuccess = action.payload;
            state.allFacultyError = '';
        },
        setAllFacultyError: (state, action) => {
            state.allFacultyLoading = false;
            state.allFacultySuccess = null;
            state.allFacultyError = action.payload;
        },
        resetDetails: (state) => {
            state.getQuestionSuccess = {};
            state.createFeedbackSuccess = {};
            state.getFeedbackDetailsSuccess = {};
        },
    }
})

export const { setQuestionListLoading, setQuestionListSuccess, setQuestionListError,
    setGetQuestionLoading, setGetQuestionSuccess, setGetQuestionError, 
    setGetFeedbackDetailsLoading, setGetFeedbackDetailsSuccess, setGetFeedbackDetailsError,
    setCreateQuestionLoading, setCreateQuestionSuccess, setCreateQuestionError,
    setCreateFeedbackLoading, setCreateFeedbackSuccess, setCreateFeedbackError,
    setAllFeedbacksLoading,
    setAllFeedbacksSuccess,
    setAllFeedbacksError,
    setAllFacultyLoading,
    setAllFacultySuccess,
    setAllFacultyError,
    resetDetails
} = feedbackSlice.actions;


export default feedbackSlice.reducer;